export const YEAR = 'year'
export const QUARTER = 'quarter'
export const MONTH = 'month'
export const WEEK = 'week'
export const DAY = 'day'

export const PERIOD_OPTIONS = [
  { name: 'Year', value: YEAR },
  { name: 'Quarter', value: QUARTER },
  { name: 'Month', value: MONTH },
  { name: 'Week', value: WEEK },
  { name: 'Day', value: DAY },
]
